import { render, staticRenderFns } from "./model.vue?vue&type=template&id=02abaa95&scoped=true"
import script from "./model.vue?vue&type=script&lang=js"
export * from "./model.vue?vue&type=script&lang=js"
import style0 from "./model.vue?vue&type=style&index=0&id=02abaa95&prod&lang=scss"
import style1 from "./model.vue?vue&type=style&index=1&id=02abaa95&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02abaa95",
  null
  
)

export default component.exports